import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/** Icône Font Awesome de chaque thème du calendrier : les émojis rendent mal selon le système. */
const ICONES_THEME: Readonly<Record<string, string>> = {
    'hiver': 'fa-snowflake',
    'noel': 'fa-tree',
    'saint-valentin': 'fa-heart',
    'printemps': 'fa-seedling',
    'paques': 'fa-egg',
    'ete': 'fa-umbrella-beach',
    '14-juillet': 'fa-champagne-glasses',
    'automne': 'fa-leaf',
    'halloween': 'fa-ghost',
    'nouvel-an-chinois': 'fa-dragon',
    'octobre-rose': 'fa-ribbon',
    'movember': 'fa-user-tie',
    'alg-80-ans': 'fa-cake-candles',
};

export function iconeTheme(slug: string | null | undefined): string {
    return (slug && ICONES_THEME[slug]) || 'fa-star';
}

/**
 * Pastille d'un thème : dégradé de ses deux couleurs (format `r, g, b`) et icône blanche.
 * Sans couleurs, l'icône seule, dans la couleur du texte (listes en ligne).
 */
@Component({
    selector: 'app-theme-icone',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<i class="fa-solid {{ icone() }}" aria-hidden="true"></i>`,
    styles: `
        :host { display: inline-grid; place-items: center; flex-shrink: 0; line-height: 1; }
        :host(.est-pastille) {
            position: relative;
            overflow: hidden;
            border-radius: .5rem;
            color: #fff;
            box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .18), 0 1px 2px rgba(15, 23, 42, .18);
        }
        :host(.est-pastille)::after {
            content: '';
            position: absolute;
            inset: 0;
            background: linear-gradient(180deg, rgba(255, 255, 255, .28), transparent 55%);
            pointer-events: none;
        }
        :host(.est-pastille) i { position: relative; filter: drop-shadow(0 1px 1px rgba(0, 0, 0, .3)); }
    `,
    host: {
        'aria-hidden': 'true',
        '[class.est-pastille]': '!!primaire()',
        '[style.background]': 'fond()',
    },
})
export class ThemeIconeComponent {
    readonly slug = input<string | null | undefined>(null);
    readonly primaire = input<string | null>(null);
    readonly secondaire = input<string | null>(null);
    protected readonly icone = computed(() => iconeTheme(this.slug()));
    protected readonly fond = computed(() => {
        const primaire = this.primaire();
        if (!primaire) return null;
        return `linear-gradient(135deg, rgb(${primaire}), rgb(${this.secondaire() ?? primaire}))`;
    });
}
